import clipboard  from './clipboard'

const directives = {
  clipboard
};

// 批量注册
export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key])
    })
  }
}



// WEBPACK FOOTER //
// ./src/directive/directive.js